import React from "react";
import Skinkusalat from "../../resources/salat/skinkusalat.JPG";
import pesto from "../../resources/salat/pesto.JPG";
import ostasalat from "../../resources/ostasalat.JPG";
import rækjusalat from "../../resources/salat/rækjusalat.JPG";
import tunfisk from "../../resources/salat/tunfisk.JPG";
export const SalotMenu = () => {
    return (
        <div className="flex flex-col bg-[#FAF7F2] border-t border-amber-100 px-4 py-10">
            <div className="flex flex-col items-center mb-8">
                <h2 className="text-2xl md:text-3xl text-stone-900 font-serif mb-1">Brauðsalötin okkar</h2>
                <div className="w-16 h-0.5 bg-[#C29979] mb-3"></div>
                <p className="text-base md:text-lg text-stone-500 text-center font-serif max-w-xl">Við bjóðum upp á fjölbreytt úrval af brauðsalötum úr eigin eldhúsi</p>
            </div>
            <div className="flex flex-wrap justify-center items-stretch gap-4 max-w-5xl mx-auto w-full">
                {[
                    { label: "Skinkusalat", src: Skinkusalat, alt: "skinkusalat" },
                    { label: "Döðlupestó", src: pesto, alt: "pesto" },
                    { label: "Ostasalat", src: ostasalat, alt: "ostasalat" },
                    { label: "Rækjusalat", src: rækjusalat, alt: "rækjusalat" },
                    { label: "Túnfisksalat", src: tunfisk, alt: "tunfisk" },
                ].map(({ label, src, alt }) => (
                    <div key={label} className="flex flex-col items-center bg-white rounded-xl border border-amber-100 shadow-sm overflow-hidden w-[45%] sm:w-[28%] md:w-[18%] hover:shadow-md transition-shadow">
                        <img src={src} alt={alt} className="w-full h-36 object-contain bg-amber-50"/>
                        <p className="text-stone-800 font-serif font-medium text-sm py-3 px-2 text-center">{label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SalotMenu;
